import React, { FC, createRef, useState, useEffect } from 'react'
import { CheckIcon, XIcon } from '@heroicons/react/outline'
import { StyledLessonPreviewTooltip, PreviewLessonType } from '.'
import { Button } from '../System'

type Props = {
  lesson: PreviewLessonType;
  hideTooltip: () => void;
}

const LessonPreviewTooltip: FC<Props> = ({ lesson, hideTooltip }) => {
  const [tooltipHeight, setTooltipHeight] = useState(0)
  const tooltipRef = createRef<HTMLDivElement>()

  useEffect(() => {
    if (!tooltipRef.current) {
      return
    }

    setTooltipHeight(tooltipRef.current.getBoundingClientRect().height)
  }, [tooltipRef])

  return (
    <StyledLessonPreviewTooltip
      ref={tooltipRef}
      height={tooltipHeight}
      x={lesson.modalX}
      y={lesson.modalY}
    >
      <div className="lesson-tooltip-content">
        <Button theme="outline" isIcon className="close-btn" onClick={() => hideTooltip()}>
          <XIcon />
        </Button>
        <span className="">WHAT YOU'LL LEARN</span>
        <ul className="lesson-bullets">
          {lesson.offeringsDescription!.map((bullet, index) => {
            return (
              <li key={index}>
                <CheckIcon />
                {bullet}
              </li>
            )
          })}
        </ul>
      </div>
    </StyledLessonPreviewTooltip>
  )
}

export default LessonPreviewTooltip
